import React, { useEffect } from "react";
const cardData = [
  {
    id: "1",
    name: "Customizable Learning",
    iconColor: "green",
    textColor: "text-green-300",
    desc: "Shape your learning to match your goals and schedule. Our flexible courses let you learn at your own speed, fitting perfectly with your lifestyle.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 464 511.644"
      >
        <g
          id="Customizable_Learning"
          data-name="Customizable Learning"
          transform="translate(-24 511.544)"
        >
          <path
            id="Path_1"
            data-name="Path 1"
            d="M238.8-510.6c-22.2,4-40.2,13.2-57,29.4-15,14.4-24.2,30.4-29.4,51-4.2,16.6-2.8,23.2,4.9,23.2,4.9,0,6.5-2.4,8.2-12.4a149.182,149.182,0,0,1,3.6-14.9c9.7-28.8,34.3-51.7,64.4-59.9,11.4-3,34.5-3.1,45.7,0,33.3,9.1,58.9,35,67,67.7,2.9,11.8,3.1,30.4.4,42-3.3,14.4-8.2,23.4-36.4,67.2L283-275.1v6.3c0,6.2-1.9,11.2-3.6,9.5-.4-.4.2-17.9,1.5-39,1.2-21,2.1-39,2.1-40,0-1.4.9-1.7,5.9-1.7,17.7,0,28.8-13.9,24-30.1-4.7-15.5-25.8-20.2-37.1-8.2-3.7,3.8-5.4,8.5-6.3,16.5l-.7,6.8H243.2l-.7-6.8c-1.2-11.2-4.8-17.2-12.7-21.3-4.9-2.5-13.9-2.5-19.4,0-10.4,4.7-15.5,18.9-10.5,29.6,4,8.7,12.3,13.5,23.2,13.5H229v3.7c0,2.1.9,18.2,2,35.8s2,34.2,2,37c-.1,4.6-.2,4.8-1.5,3.1-1-1.3-1.5-4.3-1.5-8.4v-6.3l-27-42.1c-14.9-23.1-28.1-44.1-29.4-46.7a101.39,101.39,0,0,1-5.1-13.4c-3.1-9.9-6-13.3-10.5-12.2-6.4,1.6-7.4,5.8-3.9,17.1,3.5,11.5,8.6,20.4,35,61.4l25.3,39.4.8,7.4c.9,8.5,2.5,11.9,7.1,15.9,3.3,2.7,3.4,3.1,4,12,.7,10.9,2.8,16.4,8.2,21.2,6,5.3,9.1,6.1,22.2,6.1,13.4,0,17.9-1.5,23.4-7.7,4.6-5.3,6-9.4,6.6-19.7.6-8.8.7-9.2,4-11.9,4.6-4,6.2-7.4,7.1-15.9l.8-7.4L324-311c13.9-21.7,27-42.9,29.1-47,17.2-34.3,13.1-78.6-10.1-109.9-7.5-10.1-20.9-22.5-30.9-28.5a123.878,123.878,0,0,0-33-13.2C269.7-511.7,248.2-512.2,238.8-510.6ZM225.2-368.3c.9,1,1.9,4.4,2.3,7.5l.6,5.8H223c-4.1,0-5.6-.5-7.5-2.5A7.358,7.358,0,0,1,215-368C217.5-370.5,223.1-370.7,225.2-368.3Zm71.8.3a7.358,7.358,0,0,1-.5,10.5c-1.9,2-3.4,2.5-7.5,2.5h-5.1l.6-5.8c.4-3.1,1.4-6.5,2.3-7.5C288.9-370.7,294.5-370.5,297-368Zm-29.3,37.2c-.3,5.1-1.4,23.4-2.3,40.5L263.6-259H248.4l-1.8-31.3c-.9-17.1-2-35.4-2.3-40.5l-.6-9.2h24.6Zm4.3,91.5c0,6.6-1.7,12-4.3,13.8-3,2.1-19.4,2.1-22.4,0-2.6-1.8-4.3-7.2-4.3-13.8V-244h31Z"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M103.1-481.4c-2.4,3-2.7,6.3-.8,8.6.6.9,5.4,5.2,10.5,9.7,6.8,5.9,10,8.1,12.1,8.1a7.3,7.3,0,0,0,7.1-7.3c0-3.4-2.3-6.1-15.2-17.5C110.9-485,106.3-485.5,103.1-481.4Z"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M391-474.9c-8.9,8.1-10,9.4-10,12.4a7.3,7.3,0,0,0,7.2,7.5c2,0,5.1-2.1,11.5-7.6,4.8-4.1,9.6-8.5,10.6-9.6,3.8-4.5.2-11.8-5.9-11.8C401.5-484,399.5-482.7,391-474.9Z"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M121.3-421.7c-4.4,2.5-19.3,16.9-19.9,19.4-1.4,5.3,5.1,10.7,9.9,8.1,2.1-1,10.5-8.1,17.5-14.6,4.2-4,4.5-9.1.6-12.1C126.4-423.3,124.5-423.5,121.3-421.7Z"
          />
          <path
            id="Path_5"
            data-name="Path 5"
            d="M383.6-420.9a7.562,7.562,0,0,0-.8,10.6c2.9,3.3,16.6,14.9,18.9,16.1,4.8,2.6,11.3-2.8,9.9-8.1-.3-1.4-4.5-6.1-9.2-10.4C390.2-423.8,388.3-424.6,383.6-420.9Z"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            d="M81-342.1a16.475,16.475,0,0,0-8.4,12.6l-.7,4.5H54.6c-16.1,0-17.6.2-21.6,2.3a15.487,15.487,0,0,0-6.7,6.7L24-311.7v135.1c0,118.2.2,135.9,1.5,141.1C30.1-18.1,43.8-4.8,60.8-1.1,68.3.5,443.6.5,451.2-1.1c17-3.6,30.7-17,35.3-34.4,1.3-5.2,1.5-22.9,1.5-141.1V-311.7l-2.3-4.3a15.487,15.487,0,0,0-6.7-6.7c-4-2.1-5.5-2.3-21.1-2.3H441.1l-.7-4.5a16.475,16.475,0,0,0-8.4-12.6c-3.2-1.7-6.3-1.9-36.3-1.9-19.1,0-33.6.4-34.6,1a7.807,7.807,0,0,0-3,3.9c-1,2.4-1,3.4.3,6,.9,1.7,1.8,3.2,1.9,3.3s14.8.5,32.7.8l32.5.5.3,47.6c.2,46.2.3,47.7,2.2,49.4a7.786,7.786,0,0,0,10.3-.4c2.2-2.1,2.2-2.6,2.5-40.2l.3-38,15.7.3,15.7.3v271l-2.8,5.7a33.334,33.334,0,0,1-15.6,15.2l-4.6,2.1H62.5l-4.6-2.1A33.334,33.334,0,0,1,42.3-32.8l-2.8-5.7v-271l16.2-.3L72-310l.2,130.7.3,130.8,2.3,4.2a21.4,21.4,0,0,0,6.4,7l4.2,2.8H427.6l4.2-2.8a21.4,21.4,0,0,0,6.4-7l2.3-4.2v-79.6c0-77-.1-79.8-1.9-81.8-2.5-2.7-8.6-2.9-10.9-.3-1.5,1.7-1.7,7.1-1.7,57.5V-97H362.8c-69.6,0-71.2.2-82.9,6a70.785,70.785,0,0,0-11.1,7.2L264-79.9v-49.4c0-48.5,0-49.5-2.1-52.1a6.75,6.75,0,0,0-10.8,0c-2.1,2.6-2.1,3.6-2.1,52.2v49.6l-2.7-2.6c-4.6-4.2-13.6-9.5-20.4-11.9-5.8-2.1-8.7-2.3-29.6-2.7L173-97.2l-3.1,3.1c-2.5,2.5-3,3.7-2.5,5.9,1.4,5.8,2.8,6.2,25,6.2,22.7,0,28.6,1,37.5,6.3,6.7,4,11.5,9.5,15.2,17.2C250.2-47.9,259-49,169-49H90l-1.5-2.4c-1.3-1.9-1.5-5-1.3-16.2l.3-13.9,29.8-.5c28.1-.5,29.9-.6,31.3-2.4,2.3-3.3,1.8-8.2-1.2-10.5-2.6-2-3.8-2.1-31.5-2.1H87l.2-115.8.3-115.7L120-329c17.9-.3,32.6-.7,32.7-.8s1-1.6,1.9-3.3c1.3-2.6,1.3-3.6.3-6a7.807,7.807,0,0,0-3-3.9c-1-.6-15.5-1-34.6-1C87.3-344,84.2-343.8,81-342.1ZM425.8-67.6c.2,11.2,0,14.3-1.3,16.2L423-49H344c-90,0-81.2,1.1-76.1-9.5,3.7-7.7,8.5-13.2,15.2-17.2,10.4-6.2,10-6.2,79.4-6l63,.2Z"
          />
          <path
            id="Path_7"
            data-name="Path 7"
            d="M103.5-256.5a8.236,8.236,0,0,0-2.5,5,8.236,8.236,0,0,0,2.5,5l2.4,2.5h79.2l2.4-2.5a8.236,8.236,0,0,0,2.5-5,8.236,8.236,0,0,0-2.5-5l-2.4-2.5H105.9Z"
          />
          <path
            id="Path_8"
            data-name="Path 8"
            d="M325.5-256.5a8.236,8.236,0,0,0-2.5,5,8.236,8.236,0,0,0,2.5,5l2.4,2.5h79.2l2.4-2.5a8.236,8.236,0,0,0,2.5-5,8.236,8.236,0,0,0-2.5-5l-2.4-2.5H327.9Z"
          />
          <path
            id="Path_9"
            data-name="Path 9"
            d="M117.7-219a7.522,7.522,0,0,0-.7,11c1.9,1.9,3.3,2,46.9,2h45l2-2.6c2.6-3.3,2.7-6.5.2-9.5l-1.9-2.4-44.4-.3C120.9-221.1,120.3-221,117.7-219Z"
          />
          <path
            id="Path_10"
            data-name="Path 10"
            d="M304.3-220c-4.5,1.8-5.5,7.2-2.2,11.4l2,2.6h45c43.6,0,45-.1,46.9-2a7.476,7.476,0,0,0-.6-10.9c-2.6-2.1-3.6-2.1-45.8-2C325.9-220.9,305.5-220.5,304.3-220Z"
          />
          <path
            id="Path_11"
            data-name="Path 11"
            d="M117-182a7.522,7.522,0,0,0,.7,11c2.6,2,3.2,2.1,47.1,1.8l44.4-.3,1.9-2.4c2.5-3,2.4-6.2-.2-9.5l-2-2.6h-45C120.3-184,118.9-183.9,117-182Z"
          />
          <path
            id="Path_12"
            data-name="Path 12"
            d="M302.1-181.4c-2.8,3.5-2.6,6.9.4,9.9l2.4,2.5h43.9c42.9,0,44,0,46.6-2.1A7.476,7.476,0,0,0,396-182c-1.9-1.9-3.3-2-46.9-2h-45Z"
          />
          <path
            id="Path_13"
            data-name="Path 13"
            d="M120-147.3c-5.1,1.9-6.8,8.5-3,12.3,1.9,1.9,3.3,2,46.9,2h45l2-2.6a9.557,9.557,0,0,0,2.1-4,8.8,8.8,0,0,0-5.3-7.4C204.6-148,122.9-148.4,120-147.3Z"
          />
          <path
            id="Path_14"
            data-name="Path 14"
            d="M305.1-146.9c-5.2,2.1-6.5,6.9-3,11.3l2,2.6h45c43.6,0,45-.1,46.9-2,2.7-2.7,2.6-8.1-.1-10.6-2-1.8-4.4-1.9-45.3-2.1C324.3-147.8,306.6-147.5,305.1-146.9Z"
          />
        </g>
      </svg>
    ),
  },
  {
    id: "2",
    name: "High-Performance Skills",
    desc: "Get the skills that are in high demand and boost your career. Our courses give you the latest industry knowledge and practical abilities.",
    iconColor: "blue",
    textColor: "text-blue-300",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 478.736 495.873"
      >
        <g
          id="High-Performance_Skills"
          data-name="High-Performance Skills"
          transform="translate(-16.139 503.873)"
        >
          <path
            id="Path_1"
            data-name="Path 1"
            d="M419.2-502.5c-14.4,3.4-29,13.9-37.2,26.6-12.5,19.4-12.5,46.5,0,65.5,8.8,13.5,24.9,24.6,39.7,27.5,9.4,1.8,23.4.8,32.2-2.4a62.043,62.043,0,0,0,39.6-45.2c6.6-31.7-13-63.6-44-71.5C440.5-504.3,427.4-504.5,419.2-502.5Zm22.4,14.6a45.4,45.4,0,0,1,33.1,25.5c3.2,6.7,3.8,9,4.1,16.7,1,19.8-8.3,35.7-25.5,43.9C422.9-387.4,388-409.4,388-443a44.3,44.3,0,0,1,11.8-30.3c6.1-6.4,11.3-9.9,18.7-12.5C428-489.1,432.6-489.6,441.6-487.9Z"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M446.9-466c-.8.5-5.5,6.5-10.4,13.5l-9,12.5-2.8-3c-4.9-5.3-11.6-5-13.7.6-1.3,3.4-.5,6,3.5,10.9,8,9.7,10.1,11.5,13.7,11.5,4.3,0,4.7-.4,18.7-20.4,8.7-12.4,11.1-16.6,11.1-19.2C458-464.9,451.6-468.7,446.9-466Z"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M91.3-482.6c-18.3,4.5-34.4,21-38.2,39.4C46.6-411.9,70.9-382,102.7-382c14.6,0,26.1-4.8,36.3-15s15-21.7,15-36.1C154-465.5,122.8-490.2,91.3-482.6Zm25.5,17.2c10.8,4.8,17.5,12.4,20.7,23.8,3.4,11.7-.2,24.4-9.3,33.5-5.9,5.9-10.8,8.5-18.9,10.2-14.6,3-30.5-5-38-19.2-2.6-4.9-2.8-6.3-2.8-15.9s.3-11,2.8-15.8C80.2-465.6,100.1-472.9,116.8-465.4Z"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M226.7-465.8c-2.4,1.9-3.8,6.4-2.8,9.1,2.1,5.4-.2,5.2,63.2,5.2h58.8l2.3-2.2c3.1-3.1,3-8.9-.1-11.4-2.2-1.8-5.2-1.9-61-1.9C241.7-467,228-466.7,226.7-465.8Z"
          />
          <path
            id="Path_5"
            data-name="Path 5"
            d="M226-406.2c-2.8,2.3-3.1,8.3-.5,11.2,1.8,2,2.8,2,43,2,38.6,0,41.3-.1,42.8-1.8,2.4-2.6,2.2-8.7-.3-11.2-1.9-1.9-3.3-2-42.4-2C231.3-408,228.1-407.9,226-406.2Z"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            d="M51.1-359.9c-17.2,3.4-30.9,17.6-34.1,35.1-.7,3.6-1,29.6-.8,73.5l.3,67.8,2.8,5.7c5.1,10.4,13.6,15.6,26.8,16.5l7.9.6v74.3C54-13.3,54-12,56-10c1.9,1.9,3.3,2,46.8,2h44.9l2.1-2.3,2.2-2.3V-162h5.8c13,0,22.5-5.4,27.9-15.9l3.3-6.3v-70.7c0-79.1.2-76-7.1-87a45.52,45.52,0,0,0-20.8-16.3c-5.5-2.3-6.1-2.3-55.6-2.5C78-360.8,53.5-360.4,51.1-359.9Zm104.2,15.5c6,2,12.9,8.2,15.8,14.1l2.4,4.8.3,68.2c.3,75.4.5,73.3-6,77.3-2.4,1.4-5,2-9.5,2H152v-62.9c0-58.4-.1-63-1.7-65a7.586,7.586,0,0,0-10.6-1.1l-2.7,2.1-.2,140.7-.3,140.7-13.2.3-13.3.3v-75c0-71.7-.1-75-1.9-77.2-2.3-2.9-8.1-3.1-11-.5-2.1,1.9-2.1,2.8-2.3,77l-.3,75.1-12.6.3-12.6.3-.7-140.8-.7-140.8-2.5-2.3c-3.1-2.8-6.4-2.8-9.8-.1l-2.6,2V-178H46.5c-6,0-6.8-.3-10.3-3.4l-3.7-3.4-.3-69.7L32-324.2l2.3-5.2A28.642,28.642,0,0,1,52-345.1c1.4-.4,24.1-.8,50.6-.8C143.9-346,151.3-345.8,155.3-344.4Z"
          />
          <path
            id="Path_7"
            data-name="Path 7"
            d="M424.9-350c-22.3,3.5-41.5,19.3-48.9,40.3-15.8,45,23.8,90.1,70.4,80.2,33-7,54.1-39.7,47.1-72.8-3.1-14.8-13.4-29.8-26.2-38.3C455.9-348.2,438.3-352.1,424.9-350Zm20.6,16.5a46.652,46.652,0,0,1,29.8,25.2c3,6.5,3.2,7.4,3.2,18.8,0,11.8-.1,12.1-3.7,19.7a42.34,42.34,0,0,1-21.5,21.6c-6.6,3.1-8.9,3.7-16.6,4-11,.6-19.4-1.5-27.5-6.7-20.1-13.1-26.8-37.6-16.1-59.8,3-6.3,13.1-16.3,19.4-19.3A48.07,48.07,0,0,1,445.5-333.5Z"
          />
          <path
            id="Path_8"
            data-name="Path 8"
            d="M448-311.9c-1.5.6-6,5.8-11.4,13.5l-8.9,12.5-3.1-2.9c-4-3.7-5.9-4.4-9.5-3.1a7.746,7.746,0,0,0-4.5,9.1c1.1,3.7,14.4,16.8,17,16.8,5.4,0,7-1.8,26.7-30.3,4.8-7,5.7-10.8,3.4-13.8C456.1-312.2,451.2-313.1,448-311.9Z"
          />
          <path
            id="Path_9"
            data-name="Path 9"
            d="M228-325.7c-5.6,2.8-5.8,11.7-.3,13.8,3.3,1.2,116.9,1.2,119.2-.1,3.1-1.6,4.5-6.4,2.9-9.6C347.3-327,348-327,287-327,243.4-327,229.9-326.7,228-325.7Z"
          />
          <path
            id="Path_10"
            data-name="Path 10"
            d="M228-266.7c-5.6,2.8-5.8,11.1-.4,13.6,3.1,1.4,115,1.6,118.7.2a7.288,7.288,0,0,0,3.5-9.7C347.3-268,348-268,287-268,243.4-268,229.9-267.7,228-266.7Z"
          />
          <path
            id="Path_11"
            data-name="Path 11"
            d="M419-194.4c-14.2,3.7-28.5,13.9-36.6,26.2a72.371,72.371,0,0,0-6.7,14.2c-5.1,14.6-3.8,33,3.3,47,3.2,6.4,10.9,15.6,16.2,19.8,31.1,24,75.8,14.4,92.7-19.9,9.3-18.9,9.3-36.9,0-55.8A59.4,59.4,0,0,0,449.5-194C440.2-196.4,427.1-196.6,419-194.4Zm24.1,14.8C464.7-175,479-157.3,479-135c0,41.8-49.4,61.2-78.7,30.9-20.8-21.4-14-58.9,12.9-71.8C423.6-180.8,432.2-181.9,443.1-179.6Z"
          />
          <path
            id="Path_12"
            data-name="Path 12"
            d="M226-184.2c-2.8,2.3-3.1,8.3-.5,11.2,1.8,2,2.6,2,61.5,2s59.7,0,61.5-2c2.7-3,2.5-8.8-.4-11.1-2.2-1.8-5.2-1.9-61.1-1.9C232.1-186,228.1-185.9,226-184.2Z"
          />
          <path
            id="Path_13"
            data-name="Path 13"
            d="M225.9-125.1c-1.7,1.3-2.3,2.9-2.3,5.6s.6,4.3,2.3,5.6c2.1,1.7,4.4,1.9,26,1.9,23.5,0,23.8,0,25.9-2.3a6.91,6.91,0,0,0-.3-10.2l-2.4-2.5H251.7C230.2-127,228-126.8,225.9-125.1Z"
          />
        </g>
      </svg>
    ),
  },
  {
    id: "3",
    name: "Fully Featured Curriculum",
    desc: "Get access to all course materials, including video lectures and hands-on projects. Everything you need for success is in one complete package.",
    iconColor: "gray",
    textColor: "text-yellow-300",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 511.719 511.276"
      >
        <g
          id="Fully_Featured_Curriculum"
          data-name="Fully Featured Curriculum"
          transform="translate(-0.128 511.776)"
        >
          <path
            id="Path_1"
            data-name="Path 1"
            d="M20.5-510.2A29.754,29.754,0,0,0,1-488.7C.2-485,0-418.6.2-253L.5-22.5l2.1,4.6A35.333,35.333,0,0,0,17.9-2.6L22.5-.5h379l4.6-2.1a35.333,35.333,0,0,0,15.3-15.3c2-4.4,2.1-6,2.4-46.1.2-45.8.3-45.2-6-48.3-3.2-1.6-4-1.6-7-.4-6.5,2.7-6.3,1-6.8,45.9l-.5,41-3.3,2.9L397-20l-185.5-.2L26-20.5l-2.7-2.8L20.5-26V-486l2.8-2.7,2.7-2.8,185.5-.3L397-492l3.2,2.9,3.3,2.9.5,58.6.5,58.6,2.7,2.6a9.719,9.719,0,0,0,13.6,0l2.7-2.6v-60.3c0-59.5,0-60.3-2.1-64.8a35.333,35.333,0,0,0-15.3-15.3l-4.6-2.1-188-.2C37.2-511.9,25.2-511.8,20.5-510.2Z"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M195.6-456.5c-36.2,7.5-63,32.6-72.8,68.2-3.1,11.1-3.1,33.3.1,44.8a94.027,94.027,0,0,0,68.7,67.2c9.5,2.3,31.3,2.3,40.8,0,28-7,50.2-25,62.6-50.8,6.6-13.8,8.4-22,8.4-38.9,0-11.8-.5-16-2.2-22.3-9.2-33.3-34-58.1-66.9-66.8C224.1-457.8,205.2-458.5,195.6-456.5Zm37.9,21.9c11.3,3.6,19.7,8.8,29,18.1,9.4,9.4,14.5,17.7,18.2,29.5,2.4,7.3,2.7,10.2,2.7,20.5-.1,13.7-1.7,21.2-7,32-6,12.1-5.2,11.9-13.7,2.9-6.2-6.5-16.3-14.1-21.1-15.7-.5-.2.6-3.4,2.5-7.2,2.9-5.9,3.4-8,3.7-16,.5-11.2-1.3-18.7-6.4-26.2-6.8-10-16.9-15.3-29.4-15.3-22.4,0-37,17.2-35.8,42.1.3,7.3.9,9.7,3.8,15.5,1.8,3.7,2.9,6.9,2.4,7.1-4.8,1.6-14.9,9.2-21.1,15.7-8.5,9-7.7,9.2-13.7-2.9-5.4-11.1-7-18.2-6.9-32.5,0-11.3.2-13.3,3-21.2,4.2-12.2,8.5-19,17.8-28.3s17.8-14.6,29-18c10.7-3.2,12.3-3.4,24.5-3A66.466,66.466,0,0,1,233.5-434.6Zm-12.2,45.1c4.2,3.1,6.7,9.2,6.7,16.3,0,7.9-1.8,12.2-6.6,15.8-3.1,2.4-4.7,2.9-9.4,2.9-10.1,0-16-6.8-16-18.4,0-9,3.4-15.5,9.5-18.2C208.9-392.6,218.3-391.6,221.3-389.5Zm2.2,57c12.1,3.1,24.1,11.3,29.6,20.2l2.2,3.6-2.4,1.8c-4.1,3.1-16,8.6-22.9,10.5-4.5,1.3-10,1.8-18,1.8s-13.5-.5-18-1.8c-6.9-1.9-18.8-7.4-22.9-10.5l-2.4-1.8,2.2-3.6a53.03,53.03,0,0,1,7.6-8.6C190.7-332,208-336.5,223.5-332.5Z"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M459.6-385.9c-6.7,1.6-15.6,7.1-20.3,12.3-5.5,6.4-131,223.4-132.4,229.1-1.2,5.1-8.9,73.9-8.9,79.9,0,5.9,3,9.5,8.5,10.3,4.4.5,4.8.2,60-40.7l13.1-9.6,63.1-109.5c34.7-60.2,64-111.2,65.1-113.5,10.1-20.2.6-45.7-20.8-55.8-5.4-2.5-7.9-3-15-3.3C467.3-386.8,461.8-386.5,459.6-385.9Zm18.7,20.4A20.716,20.716,0,0,1,490-353.8c3.4,8,2.5,13.4-4.5,25.8-3.2,5.5-6.1,10-6.6,10-.6,0-9.3-4.8-19.4-10.6L441-339.2l1.9-3.2c1-1.7,3.1-5.4,4.7-8.1,4.5-8,8.1-12.1,12.7-14.4C465.3-367.4,473.2-367.7,478.3-365.5Zm-26.8,55.4c10,5.8,16.9,10.4,16.7,11.2-.3,1.3-97.7,170.5-99.4,172.6-.7.8-6-1.8-19.4-9.5C339.3-141.7,331-147,331-147.5c0-.6,12.4-22.6,27.7-49C434.1-327.2,431-322.1,432.8-321,433.7-320.5,442.2-315.6,451.5-310.1Zm-98.6,200c0,.7-32.1,24.2-32.5,23.8-.3-.3,3.5-35,4.2-38.4.4-2,1.3-1.7,14.4,5.9C346.7-114.3,353-110.4,352.9-110.1Z"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M77-240.7c-3.8,1.8-6.3,7.7-5,11.3,1.6,4.2,3.9,6.3,7.5,7,11.1,2.1,15.9-13.3,5.8-18.5C82.5-242.3,80.1-242.3,77-240.7Z"
          />
          <path
            id="Path_5"
            data-name="Path 5"
            d="M120.5-241.1a9.692,9.692,0,0,0-3.2,15.8l2.7,2.8,74.5.3,74.4.2,3.3-2.9c2.7-2.4,3.3-3.6,3.3-7.1s-.6-4.7-3.3-7.1L269-242l-73.3.1C155.5-241.9,121.6-241.5,120.5-241.1Z"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            d="M77-184.7c-3.8,1.8-6.3,7.7-5,11.3,1.6,4.2,3.9,6.3,7.5,7,11.1,2.1,15.9-13.3,5.8-18.5C82.5-186.3,80.1-186.3,77-184.7Z"
          />
          <path
            id="Path_7"
            data-name="Path 7"
            d="M120.5-185.1a9.692,9.692,0,0,0-3.2,15.8l2.7,2.8,74.5.3,74.4.2,3.3-2.9c2.7-2.4,3.3-3.6,3.3-7.1s-.6-4.7-3.3-7.1L269-186l-73.3.1C155.5-185.9,121.6-185.5,120.5-185.1Z"
          />
          <path
            id="Path_8"
            data-name="Path 8"
            d="M77-128.7c-3.8,1.8-6.3,7.7-5,11.3,1.6,4.2,3.9,6.3,7.5,7,11.1,2.1,15.9-13.3,5.8-18.5C82.5-130.3,80.1-130.3,77-128.7Z"
          />
          <path
            id="Path_9"
            data-name="Path 9"
            d="M120.5-129.1a9.692,9.692,0,0,0-3.2,15.8l2.7,2.8,74.5.3,74.4.2,3.3-2.9c2.7-2.4,3.3-3.6,3.3-7.1s-.6-4.7-3.3-7.1L269-130l-73.3.1C155.5-129.9,121.6-129.5,120.5-129.1Z"
          />
          <path
            id="Path_10"
            data-name="Path 10"
            d="M208.4-73c-3.2,1.3-6.4,5.9-6.4,9.1,0,1.8,1.1,4.1,2.9,6.1l2.9,3.3,30.6.3,30.5.3,3.3-3c2.7-2.4,3.3-3.6,3.3-7.1s-.6-4.7-3.3-7.1L269-74l-29.3.1C223.7-73.9,209.5-73.5,208.4-73Z"
          />
        </g>
      </svg>
    ),
  },
  {
    id: "4",
    name: "Expert Instructors",
    desc: "Learn from professionals with real-world experience. Our expert instructors offer valuable insights and guidance throughout your learning journey.",
    iconColor: "red",
    textColor: "text-red-300",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className=""
        width="30"
        height="30"
        viewBox="0 0 497.5 426.701"
      >
        <g
          id="Expert_Instructors"
          data-name="Expert Instructors"
          transform="translate(-8 468.763)"
        >
          <path
            id="Path_1"
            data-name="Path 1"
            d="M390.1-467.5C369-461.6,354-441.7,354-419.4c0,22.7,17.2,43.6,39.8,48.3,30,6.3,59.2-18,59.2-49.2,0-19.5-14.1-39.1-32.8-46C412.7-469,397.7-469.6,390.1-467.5ZM417-451.3c17.2,7.6,25.1,28,17.2,44.7-5.1,10.7-13.7,17.4-25.5,19.7-7.5,1.5-17-.7-24.4-5.6-10.4-6.9-16.8-21.5-14.4-33.2a33.833,33.833,0,0,1,9.7-18.7A32.669,32.669,0,0,1,417-451.3Z"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M12.3-426a7.494,7.494,0,0,0-3.2,2.9C8.3-421.7,8-387.2,8-311.8c0,92.9.2,109.7,1.4,111.4,1.4,1.8,3.6,1.9,70,2.4l68.6.5-41.2,58C72.2-90.7,65.6-81,65.6-78.1c0,5.5,6.2,8.9,11.2,6.2,1-.5,18.8-25.2,39.7-54.8l38-53.9.5,38.5c.3,21.2.8,39.1,1.2,39.7A10.759,10.759,0,0,0,160-100c3.5,1.4,8.3,0,9.7-2.8.4-1,1-18.8,1.3-39.6l.5-37.9,36.8,52.9c20.3,29.1,38,53.9,39.3,55.1A8.51,8.51,0,0,0,252-70c3.1,0,8-4.8,8-7.9,0-2-11.5-19.1-41-61.5-22.5-32.3-41-58.9-41-59.1,0-.3,29-.5,64.5-.5,63.2,0,64.5,0,66.5-2,1.8-1.8,2-3.3,2-14.8v-12.9l4.3-1.8c2.8-1.2,8.1-5.9,16.4-14.4L344-257.5v194l2.4,5.2c10,21.5,38.9,21.7,48.5.3,2-4.3,2.1-6.4,2.1-59.8,0-46.5.2-55.7,1.5-58.1,3-5.8,10.1-5.5,13.3.6.9,1.6,1.2,17.2,1.2,57v54.8l2.4,5.1c5,10.8,13,15.9,24.6,15.9,8.7-.1,13.3-2,19.1-8.2,7.9-8.3,7.4-1.8,7.7-86.1l.2-75.3,3.3.8a45.159,45.159,0,0,0,9.2.7c10.3-.2,18.3-5.5,23.8-15.8,2.2-4.1,2.2-4.5,2.2-54.6,0-47.3-.1-50.8-1.9-55.4a32.214,32.214,0,0,0-15.1-16.2l-5-2.4H422.6c-43.7,0-62,.3-64.8,1.2-2.6.8-5.7,3.1-9.7,7.3-5.2,5.6-26.5,30.9-33.3,39.5l-2.8,3.5v-58c0-31.9-.3-59-.6-60.3-1.5-5.5,5.7-5.2-151.6-5.1C78.6-426.9,13.5-426.5,12.3-426ZM296-363.8c0,26-.4,46.8-.8,46.3-.5-.6-3.8-5.2-7.3-10.4-8.9-13.3-17-18-28.6-16.8l-5.2.5L244-359.1c-5.5-8.2-11-15.4-12.1-16-2.6-1.3-5.8-.6-8.7,2.1-4.1,3.8-3,6.6,8.6,22.6l10.8,14.9-2.8,5.4a29.064,29.064,0,0,0-1.4,21.7c1.4,4.1,43.2,70.3,46.8,74.1a34.6,34.6,0,0,0,6.4,4.5l4.5,2.3-.3,7-.3,7H23.5l-.3-98.8L23-411H296Zm187.4,25.3c5.5,3.7,5.6,4.3,5.6,55.5,0,49.9-.1,51.2-4.8,55.3a13.305,13.305,0,0,1-5.9,2.4,11.85,11.85,0,0,1-12-7.7c-.8-2.5-1.2-15.6-1.2-45.3-.1-40.3-.2-41.8-2.1-43.7-2.8-2.8-8.1-2.6-10.8.3l-2.2,2.3-.2,127.1-.3,127.1-2.4,2.6c-3.7,3.9-9,5.2-12.9,3.2-6.8-3.5-6.6-2-7.2-64.1l-.5-56-2.8-4.8c-4-6.8-9.3-10-17.4-10.5-8.3-.6-13.9,1.6-19.1,7.2a25.938,25.938,0,0,0-5.1,8.2c-.7,2.6-1.1,22.8-1.1,58.5v54.6l-2.3,3.4c-3.1,4.6-8.6,6.5-13.1,4.4a13.757,13.757,0,0,1-5.1-4.8c-1.9-3.1-2-6.2-2.5-110.3-.4-88.8-.7-107.4-1.9-108.7-1.4-1.7-7.6-2.3-9.7-.9-.6.4-8.9,9-18.4,19.2-9.4,10.2-18.5,19.1-20,19.9-3.1,1.5-8.4.9-11.2-1.3-3.1-2.3-44.9-68.7-45.5-72.1-1.5-9.2,11.2-16.3,18.2-10.3,1.4,1.3,9.2,12.6,17.3,25.3,15.6,24.3,17.3,26.1,22.5,23.8,1.4-.7,8.9-9.2,16.7-19,23.1-28.7,34.8-42.1,37.2-42.6,1.3-.3,28.2-.4,59.8-.3C478.3-340.5,480.6-340.4,483.4-338.5Z"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M50.1-383.4c-2.7,3.4-2.7,6.4,0,9.8l2,2.6H158.9l2-2.6c2.7-3.4,2.7-6.4,0-9.8l-2-2.6H52.1Z"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M50.5-339.5c-3,3-3.2,6.4-.4,9.9l2,2.6h72.8c72.1,0,72.8,0,74.6-2,2.7-3,2.5-8.8-.4-11.1-2.2-1.8-5.5-1.9-74.3-1.9H52.9Z"
          />
          <path
            id="Path_5"
            data-name="Path 5"
            d="M52.3-298c-4.7,1.9-5.7,8.7-1.8,12.5l2.4,2.5h79.4c78.8,0,79.4,0,82.1-2.1,3.2-2.5,3.5-7.5.7-11l-1.9-2.4-79.4-.2C89.3-298.8,53.5-298.5,52.3-298Z"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            d="M50.1-252.4c-2.7,3.4-2.7,6.4,0,9.8l2,2.6h88.3c87.7,0,88.3,0,90.1-2,2.7-3,2.5-8.8-.4-11.1-2.2-1.8-5.8-1.9-90.1-1.9H52.1Z"
          />
          <path
            id="Path_7"
            data-name="Path 7"
            d="M398.6-309.9c-2.5,2-2.6,2.3-2.6,13.5,0,10.1.2,11.6,2,13.4,2.8,2.8,8.1,2.6,10.8-.3,2-2.1,2.2-3.4,2.2-13.1,0-10-.2-10.8-2.5-13.1C405.5-312.5,402.1-312.7,398.6-309.9Z"
          />
          <path
            id="Path_8"
            data-name="Path 8"
            d="M398-263c-1.8,1.8-2,3.3-2,13.4,0,11.3,0,11.5,2.7,13.6a7.586,7.586,0,0,0,10.6-1.1c1.4-1.7,1.7-4.1,1.7-13,0-12.6-1.2-14.9-7.5-14.9A8.011,8.011,0,0,0,398-263Z"
          />
        </g>
      </svg>
    ),
  },
];
const Why = () => {
  // const cardData = [
  //   {
  //     title: "Webdesign",
  //     description: "Donner du goût et de la couleur aux applications, je le fais afin de rendre vos sites attrayants. Avant de devenir webdesigner, depuis tout petit j'étais déjà familier à la couleur et au dessin.",
  //     iconColor: "green",
  //     icon: (
  //       <svg
  //         className="w-6 h-6"
  //         fill="none"
  //         stroke="currentColor"
  //         viewBox="0 0 24 24"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <path
  //           strokeLinecap="round"
  //           strokeLinejoin="round"
  //           strokeWidth="2"
  //           d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
  //         ></path>
  //       </svg>
  //     ),
  //   },
  //   {
  //     title: "Intégration web",
  //     description: "Donner du goût et de la couleur aux applications, je le fais afin de rendre vos sites attrayants. Avant de devenir webdesigner, depuis tout petit j'étais déjà familier à la couleur et au dessin.",
  //     iconColor: "blue",
  //     icon: (
  //       <svg
  //         className="w-6 h-6"
  //         fill="none"
  //         stroke="currentColor"
  //         viewBox="0 0 24 24"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <path
  //           strokeLinecap="round"
  //           strokeLinejoin="round"
  //           strokeWidth="2"
  //           d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
  //         ></path>
  //       </svg>
  //     ),
  //   },
  //   {
  //     title: "Développement Back-end",
  //     description: "Grâce à PHP et ses frameworks (Laravel, Symfony, Slim), je peux réaliser un site dynamique, c'est-à-dire qui interagit avec votre base de données. Nous pouvons essayer.",
  //     iconColor: "yellow",
  //     icon: (
  //       <svg
  //         className="w-6 h-6"
  //         fill="none"
  //         stroke="currentColor"
  //         viewBox="0 0 24 24"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <path
  //           strokeLinecap="round"
  //           strokeLinejoin="round"
  //           strokeWidth="2"
  //           d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
  //         ></path>
  //       </svg>
  //     ),
  //   },
  // ];

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://unpkg.com/pattern.css";
    document.head.appendChild(link);
  }, []);
  return (
    <section className="text-gray-200 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 lg:px-5 py-12">
        <div className="text-center mb-12">
          <span className="text-white bg-indigo-600 my-2 font-medium text-base px-4 py-1 rounded-full uppercase tracking-wider inline-block">
            Why Choose Us?
          </span>
          <h2 className="title-font mb-2 text-4xl font-extrabold leading-10 tracking-tight sm:text-5xl sm:leading-none ">
          Your Trusted Partner for IT Learning
          </h2>
          <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
          Find out what makes us different and why thousands of learners choose BrainboxStudy to reach their career goals.
          </p>
          <div className="flex mt-4 justify-center">
            <div className="w-16 h-1 rounded-full bg-indigo-500 inline-flex"></div>
          </div>
        </div>

        <div className="grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-6 h-full">
          {cardData.map((card, index) => (
            <div key={index} className="p-6 flex flex-col h-full group">
              <div className="pattern-dots-md gray-light flex flex-col h-full">
                <div className="rounded bg-gray-800 p-4 flex flex-col h-full transform translate-x-6 -translate-y-6 group-hover:scale-105 group-hover:shadow-lg transition-transform duration-300">
                  <div
                    className={`w-12 h-12 p-3 inline-flex items-center justify-center rounded-full bg-${card.iconColor}-100 text-${card.iconColor}-500 mb-5 flex-shrink-0`}
                  >
                    {card.icon}
                  </div>
                  <div className="flex-grow">
                    <h2 className={`text-lg title-font font-medium mb-2 ${card.textColor}`}>
                      {card.name}
                    </h2>
                    <p className="leading-relaxed text-[13px] text-justify">
                      {card.desc}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Why;



